export default class Discussion {
  selectReceivingCompanies(element) {
    if (!$(element).is(':checked')) return
    const form = this._fetchFromNewDiscussionEle(element)
    if ($(element).val() === 'target_all') {
      const supplierIds = form.find('.target-all-company-ids').val();
      form.find('#discussion_receiving_companies').val(supplierIds);
      form.find('.select-company').val('').prop('disabled', true).trigger('change');
    } else {
      form.find('.select-company').prop('disabled', false);
      form.find('#discussion_receiving_companies').val('[]')
    }
    form.find('.list-company-name').val('')
  }

  async removeDiscussionCompany(element, supplierId) {
    const form = this._fetchFromNewDiscussionEle(element);
    const componentViewBoxList = $(element).parents('.view_box_lists')
    componentViewBoxList.empty();
    let supplierIds = JSON.parse(form.find('#discussion_receiving_companies').val());
    supplierIds = supplierIds.filter(function(e) { return e != supplierId })
    const supplierName = []
    await gon.discussions_feature.companies.forEach(company => {
      supplierIds.forEach(supplierId => {
        if (company[0] === Number(supplierId)){
          supplierName.push(company[1]);
          componentViewBoxList.append(this._buildCompanyListItem(company[0], company[1]))
        }
      })
    });
    form.find('#discussion_receiving_companies').val(`[${supplierIds}]`)
    form.find('.list-company-name').val(supplierName);
    if (componentViewBoxList.find('li').length === 0) {
      componentViewBoxList.parents('.show-list-company-name').find('#dropdown-menu-company-list').addClass('d-none')
    }
  }

  async showSupplierName(element, company_ids = []) {
    const form = this._fetchFromNewDiscussionEle(element);
    const showCompanysToView = form.find('.show-list-company-name')
    showCompanysToView.find('.view_box_lists').empty();;

    if (form.find('.type-select-all').is(':checked')) {
      const targetCompanyIds = JSON.parse(form.find('.target-all-company-ids').val() || '[]');
      const targetCompanyNames = JSON.parse(form.find('.target-all-company-name').val() || '[]');

      form.find('#discussion_receiving_companies').val(JSON.stringify(targetCompanyIds));
      form.find('.list-company-name').val(targetCompanyNames);

      if (targetCompanyIds.length === 0) {
        showCompanysToView.find('#dropdown-menu-company-list').addClass('d-none')
      } else {
        targetCompanyIds.forEach((companyId, index) => {
          const companyName = targetCompanyNames[index] || '';
          showCompanysToView.find('.view_box_lists').append(this._buildCompanyListItem(companyId, companyName))
        });
        showCompanysToView.find('#dropdown-menu-company-list').removeClass('d-none')
      }
    } else {
      let companyIds = (form.find('.select-company').val() || []).map(id => Number(id));
      const publicSuppliers = JSON.parse(
        form.find('#discussion_receiving_companies_added_from_public_suppliers').val() || '[]'
      );
      let ids_filtered = [];

      if (publicSuppliers.length > 0) {
        companyIds = this._uniq(companyIds.concat(publicSuppliers));
      } else if (company_ids.length > 0) {
        ids_filtered = company_ids.filter(n => !companyIds.includes(Number(n)));
        form.find('#discussion_receiving_companies_added_from_public_suppliers').val(`[${ids_filtered}]`);
        companyIds = this._uniq(companyIds.concat(ids_filtered));
      }

      const supplierName = []
      await gon.discussions_feature.companies.forEach(company => {
        companyIds.forEach(companyId => {
          if (company[0] === Number(companyId)){
            supplierName.push(company[1]);
            showCompanysToView.find('.view_box_lists').append(this._buildCompanyListItem(company[0], company[1]))
          }
        })
      });

      form.find('#discussion_receiving_companies').val(`[${companyIds}]`)
      form.find('.list-company-name').val(supplierName);
      if (showCompanysToView.find('.view_box_lists').find('li').length === 0) {
        showCompanysToView.find('#dropdown-menu-company-list').addClass('d-none')
      }
      else {
        showCompanysToView.find('#dropdown-menu-company-list').removeClass('d-none')
      }
    }
  }

  showDescription(element) {
    Popup.alert($(element).val())
  }

  truncateString(str, num) {
    if (str.length > num) {
      return str.slice(0, num) + "...";
    } else {
      return str;
    }
  }

  _uniq(values) {
    return [...new Set(values.map(value => Number(value)))]
  }

  _buildCompanyListItem(companyId, companyName) {
    return $('<li>', { class: 'dropdown-item' })
      .text(this.truncateString(companyName || '', 15))
      .on('click', (event) => {
        this.removeDiscussionCompany(event.currentTarget, companyId)
      })
  }

  create(element, items) {
    const form = this._fetchFromNewDiscussionEle(element);
    const isError = this._validateDiscussion(form);
    if (isError) {
      Popup.alert(I18n.t('shared.attribute_not_blank'), 'warning')
      return
    }
    const data = {
      discussion: {
        name: form.find('#discussion_name').val(),
        receiving_companies: JSON.parse(form.find('#discussion_receiving_companies').val()),
        description: form.find('#discussion_detail').val()
      },
      receiving_companies_added_from_public_suppliers: JSON.parse(
        form.find('#discussion_receiving_companies_added_from_public_suppliers').val() || '[]'
      ),
      items_each_page: items
    }
    Shared.callAjax(Routes.owner_discussions_path(), data, 'script')
  }

  changeStatus(discussionId, statusOld, statusNew, items) {
    let textStatus = statusOld === 'going_on' ? '送信済' : '終 了';
    if (statusOld === statusNew) {
      Popup.alert(
        I18n.t('discussion.change_status.not_change', { status_old: textStatus, status_new: textStatus }), 'warning'
      )
      return
    }
    const dataParams = { id: discussionId, status: statusNew , items_each_page: items }
    Shared.callAjax(Routes.change_status_owner_discussions_path(), dataParams, 'script').fail(function(response) {
      if (response.status === 403) {
        Popup.alert(response.responseJSON?.message || I18n.t('shared.one_error_please_try_again'), 'warning');
        return
      }

      Popup.alert(I18n.t('shared.one_error_please_try_again'), 'warning');
    })
  }

  showChangeStatus() {
    $('.button_status').on('click', function(){
      $(this).find('.change_status').slideDown(300,function(){
        $('.change_status').on('mouseleave', function(){
          $('.change_status').slideUp(300)
        })
      });
    })
  }

  reset(element) {
    const form = this._fetchFromNewDiscussionEle(element);
    form.find('.select-company').val('').trigger('change');
    form.find('.type-select-one').prop('checked', true).trigger('click');
    form[0].reset();
    form.find('#discussion_receiving_companies').val('[]');
    form.find('#discussion_receiving_companies_added_from_public_suppliers').val(form.find('.initial-public-supplier-ids').val() || '[]');
    form.find('#dropdown-menu-company-list').addClass('d-none');
    form.find('.view_box_lists').empty();
  }

  copy(discussionId) {
    if (discussionId === '') return
    const description = $(`#discussionDetail_${discussionId} textarea`).val();
    $('#discussion_detail').val(description);
  }

  showAllCompany(element) {
    const listCompany = $(element).parents('.list-link-to-company');
    Visiable.show(listCompany.find('.show-last-company'))
    Visiable.show(listCompany.find('.read-less-button'))
    Visiable.hide($(element))
  }

  readLessCompany(element) {
    const listCompany = $(element).parents('.list-link-to-company');
    Visiable.show(listCompany.find('.read-more-button'))
    Visiable.hide(listCompany.find('.show-last-company'))
    Visiable.hide($(element))
  }

  _fetchFromNewDiscussionEle(element) {
    return $(element).parents('#new_discussion');
  }

  _validateDiscussion(form) {
    let isError = false;
    const arrayInputCheck = ['discussion_name', 'discussion_receiving_companies', 'discussion_detail'];
    form.find('input').toArray().forEach(input => {
      if (arrayInputCheck.includes($(input).attr('id')) && ($(input).val() === '' || $(input).val() === '[]')) {
        Shared.errorFieldMessage($(input), I18n.t('shared.attribute_not_blank'));
        if ($(input).attr('id') === 'discussion_receiving_companies') {
          Shared.errorFieldMessage(form.find('.list-company-name'), I18n.t('shared.attribute_not_blank'));
        }
        isError = true;
      }
    })
    if (form.find('#discussion_detail').val() === '') {
      Shared.errorFieldMessage(form.find('#discussion_detail'), I18n.t('shared.attribute_not_blank'));
      isError = true;
    }
    return isError;
  }

  showHideListDiscussion() {
    if (sessionStorage.getItem('showListDiscussion')) {
      sessionStorage.removeItem('showListDiscussion')
    } else {
      sessionStorage.setItem('showListDiscussion', true)
    }
    this.handleShowHideListDiscussion()
  }

  handleShowHideListDiscussion() {
    let text = ''
    if (sessionStorage.getItem('showListDiscussion')) {
      text = '新規作成'
      $('.show-add-discussion').addClass('d-none')
      $('.show-list-discussion').removeClass('d-none')
    } else {
      $('.show-add-discussion').removeClass('d-none')
      $('.show-list-discussion').addClass('d-none')
      text = '送信履歴'
    }
    $('.text-show-hide-list-discussion').text(text)
  }

  openChangePlanModalFromRestriction() {
    $('#discussionPlanRestrictedModal').modal('hide');
    $('#changePlanModal').modal('show');
  }
}

function appendDiscussion(form, discussion, suppliersName) {
  form.find('#discussion_name').val(discussion.name);
  form.find('.type-select-one').trigger('click');
  form.find('#discussion_detail').val(discussion.description);
  form.find('#discussion_receiving_companies').val(`[${discussion.receiving_companies}]`);
  form.find('.select-company ').val(discussion.receiving_companies).trigger('change')
  form.find('.list-company-name').val(suppliersName);
}
